import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import bannerphoto from '../assets/homebanner.png';
import textphoto from '../assets/textphoto.png';
import '../style/home.css';
import settingicon from '../assets/settingicon.png';
import CountUp from 'react-countup';
import news1 from '../assets/news1.png';
import news2 from '../assets/news2.png';
import newscircleimage from '../assets/circlenews.png';
import localleft from '../assets/Left.png';
import shopcentral from '../assets/shopcentral.png';
import Rightshop from '../assets/Right.png';
import farmers1 from '../assets/farmers1.png';
import farmers2 from '../assets/farmers2.png';
import farmers3 from '../assets/farmers3.png';
import appstore from '../assets/gallaxystore.png';
import playstore from '../assets/appstore.svg';

import mobileimage from '../assets/smartphone.png';
import clearall from '../assets/clear_all.png';
import bookmark from '../assets/bookmarks.png';
import searchicon from '../assets/search.png';
import product1 from '../assets/product1.png';
import product2 from '../assets/product2.png';
import product3 from '../assets/product3.png';
import bestmatch from '../assets/bestmatch.png';

function Home() {
  const counters = [
    { value: 287, suffix: '+', title: 'Vendor Marketplace' },
    { value: 16, suffix: 'M+', title: 'Connecting Sellers' },
    { value: 89, suffix: '%', title: 'Empowering Buyers' },
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="homebanner">
        <Container>
          <Row>
            <Col md="5">
              <img src={bannerphoto} alt="bannerphoto" className="bannerphoto" />
            </Col>
            <Col md="7">
              <div className='bannerrighttext'>
                <h1><span>Support Local <img src={textphoto} className="textphoto" alt="textphoto" /> Vendors,</span> Buy Fresh Anytime</h1>
                <div className='bannericonandtext'>
                  {/* <img src={planticon} alt="plant icon"/> */}
                  <p>At Local Roots, we believe that local businesses are the heart of every community. Our marketplace connects you with a diverse range of independent vendors offering quality products made with care and purpose. From everyday essentials to unique finds, shopping on Local Roots means discovering businesses that value craftsmanship, authenticity, and community. We’re here to make shopping local effortless, meaningful, and accessible….anytime, anywhere.</p>
                </div>
                <ul>
                  <li><Link to="/AboutUs">Learn More</Link></li>
                </ul>
                <div className='featuredrow'>
                  {counters.map((counter, index) => (
                    <Col md={4} key={index}>
                      <h2 className="display-5">
                        <CountUp end={counter.value} duration={2.5} />
                        {counter.suffix}
                      </h2>
                      <h5 className="mt-2">{counter.title}</h5>
                      <p className="text-muted">Discover a world of possibilities</p>
                    </Col>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='hometrackconnect'>
        <Container>
          <Row className='align-items-center trackconnect'>
            <Col md="6">
              <h2>Follow Vendors<span>and Get Real-Time Updates</span> Easily</h2>
            </Col>
            <Col md="6">
              <h3>Discover & Connect with Local Businesses</h3>
              <p>Discover a world of possibilities with Local Roots, where sellers from across industries come together to offer a diverse array of products. Whether you're looking for everyday essentials, handcrafted goods, or unique finds, Local Roots connects you directly with the businesses behind the products making it easy to shop local, support small, and find something truly special every time.</p>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Row>
                <Col md="6">
                  <img src={news1} className='newsmain' alt="News 1"/>
                </Col>
                <Col md="6">
                  <div className='newscontent'>
                    <ul className='sellertext'>
                      <li>News</li>
                      <li>October 5, 2024</li>
                    </ul>
                    <h4>Local Businesses at Your Fingertips</h4>
                    <p>Local Roots brings together independent sellers offering products you won’t find anywhere else. From the passion behind each creation to the care that goes into every detail, we make it easy to discover and shop from real businesses doing what they love. Every order supports small business owners and helps fuel local economies. It’s shopping that feels good—simple, meaningful, and made for people who value something different.</p>
                    <ul className='newstags'>
                      <li>#Marketplaces</li>
                      <li>#Shoppers</li>
                    </ul>
                    <img src={newscircleimage} alt="News circle"/>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md="6">
              <Row>
                <Col md="6">
                  <img src={news2} className='newsmain' alt="News 2"/>
                </Col>
                <Col md="6">
                  <div className='newscontent'>
                    <ul className='sellertext'>
                      <li>News</li>
                      <li>October 5, 2024</li>
                    </ul>
                    <h4>Marketplaces Revolutionizing Online Shopping</h4>
                    <p>Lorem a world of possibilities w VendorHub where sellers from across industi gather offer you a diverse array of products Whether you're looking</p>
                    <ul className='newstags'>
                      <li>#Marketplaces</li>
                      <li>#Shoppers</li>
                    </ul>
                    <img src={newscircleimage} alt="News circle"/>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='homelocalfarmer'>
        <Container>
          <Row>
            <Col md="6">
              <img src={localleft} alt="Local farmer"/>
            </Col>
            <Col md="6">
              <h2>Your Local Farmer, <span> Just a <br/>Click</span> Away</h2>
              <Row className='shopcentrallines'>
                <Col md="3">
                  <h5>Shop Central</h5>
                  <img src={shopcentral} alt="Shop central"/>
                </Col>
                <Col md="9">
                  <p>Discover a world of possibilities with VendorHub where sellers from across int gather offer you a diverse array of products Whether you're looking</p>
                  <p>Discover a world of possibilities with VendorHub where sellers from across int gather offer you a diverse array of products Whether you're looking</p>
                  <Link to='/AboutUs'>Learn More</Link>
                </Col>
              </Row>
              <Row className='countersection'>
                {counters.map((counter, index) => (
                  <Col md={4} key={index}>
                    <h2 className="display-5">
                      <CountUp end={counter.value} duration={2.5} />
                      {counter.suffix}
                    </h2>
                    <h5 className="mt-2">{counter.title}</h5>
                    <p className="text-muted">Discover a world of possibilities</p>
                  </Col>
                ))}
              </Row>
              <Link className='marketplacebutton' to='/AboutUs'>A Marketplace Powered by Vendors Together for You</Link>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='homemap'>
        <Container>
          <Row>
            <Col md="8">
              <h2>Find Vendors on the <span>Map & Visit</span> Their Profiles</h2>
              <p>Browse vendor profiles, see what they're selling, and place orders directly. Whether you're looking for fresh vegetables, organic honey, or handmade crafts, find everything in one place.</p>

              <Row>
                <Col md="6">
                  <div className='venderbox'>
                    <h3>Vendor Shopping</h3>
                    <p>Discover a world of possibilities with VendorHub where sellers from across industi</p>
                  </div>
                </Col>
                <Col md="6">
                  <div className='venderbox'>
                    <h3>Vendors Together</h3>
                    <p>Discover a world of possibilities with VendorHub where sellers from across industi</p>
                  </div>
                </Col>
              </Row>
              <Row className='poweredvendors'>
                <Col md="3">
                  <h4>Powered by Vendors</h4>
                </Col>
                <Col md="9">
                  <p>Easily find vendors and farmers in your area using our interactive map. Browse by location and connect with sellers offering fresh produce, handmade goods, and more!</p>
                  <p>Browse vendor profiles, see what they're selling, and place orders directly. Whether you're looking for fresh vegetables, organic honey, or handmade crafts, find everything in one place.</p>
                </Col>
              </Row>
            </Col>
            <Col md="4">
              <img src={Rightshop} alt="Right shop"/>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='localfarmers'>
        <Container>
          <Row>
            <Col md="12">
              <h2>Find <span>Local Farmers</span> on <br/>the Map</h2>
            </Col>
          </Row>
          <Row className='discoverbefore'>
            <Col md="6">
              <h3>Discover Fresh, Locally <br/> Grown Goods Near You</h3>
              <div className='freshpointswrapper'>
                <div className='freshpoints'>
                  <img src={farmers1} alt="Farmer 1"/>
                  <p>Easily find vendors and farmers in your area</p>
                </div>
                <div className='freshpoints'>
                  <img src={farmers2} alt="Farmer 2"/>
                  <p>Easily find vendors and farmers in your area</p>
                </div>
                <div className='freshpoints'>
                  <img src={farmers3} alt="Farmer 3"/>
                  <p>Easily find vendors and farmers in your area</p>
                </div>
              </div>

              <div className='applicationdownload'>
                <img src={appstore} alt="App Store"/>
                <img src={playstore} alt="Play Store"/>
              </div>
            </Col>
            <Col md="6">
              <div className='mobileimage'>
                <img src={mobileimage} alt="Mobile app"/>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='vreifiedvendors'>
        <Container>
          <Row>
            <Col md="12">
              <h2>Shop Directly from <span>Verified Vendors</span></h2>
            </Col>
          </Row>
          <Row className='searchform'>
            <Col md="5">
              <div className='shopbestmatch'>
                <ul>
                  <li><img src={clearall} alt="Clear all"/></li>
                  <li><img src={bookmark} alt="Bookmark"/></li>
                  <li><Link to='/VendorListing'>Best Match</Link></li>
                  <li><Link to='/VendorListing'>Newest</Link></li>
                  <li><Link to='/VendorListings'>Trending</Link></li>
                </ul>
              </div>
            </Col>
            <Col md="7">
              <div className="search-bar">
                <select className="filter-dropdown">
                  <option value="latest">Latest</option>
                  <option value="popular">Popular</option>
                  <option value="trending">Trending</option>
                </select>
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search Bringing Vendors Together........"
                />
                <button className="search-button">
                  <img src={searchicon} alt="Search"/>
                </button>
              </div>
            </Col>
          </Row>
          {/* <Row>
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </Row> */}
        </Container>
      </section>
    </div>
  );
}


export default Home;
